import { Format } from "../core/elements/format"
import { Series } from "../series"
import { Animation, Annotation } from "../tools/index"

/**
*@constructor
*@memberOf Tee
*@class Parameters to draw a circular gauge meter.
*@property {Number} [min=0] The minimum gauge range value.
*@property {Number} [max=100] The maxnimum gauge range value.
*@property {Number} [step=0] The increment between gauge range labels.
*@property {Number} [value=0] The position of gauge hand inside the min max range.
*@property {Number} [angle=280] Amount in degrees of the circular gauge size.
*@property {Number} [rotation=0] Gauge rotation in degrees.
*@property {Boolean} [rotateText=false] Gauge labels are rotated or not according to label angle position.
*@property {String} [shape="circle"] Gauge style ("circle", "rectangle", "segment").
*@property {Boolean} [drag.enabled=true] Allows mouse/touch dragging the Gauge hand to change current value.
*@property {Tee.Format} bevel Formatting properties to outmost external gauge bevel.
*@property {Tee.Format} center Formatting properties for center gauge symbol.
	*/
let NumericGauge = function(o, o2) {
	Series.call(this, o, o2);

	this.useAxes = false; // no axis
	this.legend.visible = false;

	// Range and value:

	this.min = 0;
	this.max = 100;
	this.step = 0;
	this.value = 0;

	// Rotation options:
	this.angle = 280; // degree
	this.rotation = 0; // degree
	this.rotateText = false;
	this.shape = 'rectangle'; // rectangle, segment

	this.drag = { enabled: true };

	var be = (this.bevel = new Format(this.chart));
	be.gradient.visible = true;
	be.gradient.colors = ['white'];
	be.shadow.visible = false;
	be.visible = false;
	be.stroke.fill = '';

	var ce = (this.center = new Format(this.chart));
	ce.stroke.fill = '';
	ce.gradient.visible = true;
	ce.size = 10;
	ce.visible = false;
	ce.shadow.visible = true;
	ce.gradient.offset = { x: 2, y: -2 };
	ce.location = { x: 0, y: 0 }; // %

	ce.top = new Format(this.chart);
	ce.top.size = 40; // %
	ce.top.visible = true;
	ce.top.stroke.fill = '';
	ce.top.gradient.colors = ['silver', 'white'];
	ce.top.gradient.visible = true;
	ce.top.gradient.direction = 'topbottom';

	var ti = (this.ticks = new Format(this.chart));
	ti.length = 6; // %
	ti.stroke.fill = 'silver';
	ti.visible = true;
	ti.outside = true;
	ti.triangle = false;
	ti.fill = 'white';

	var tb = (this.ticksBack = new Format(this.chart));
	tb.stroke.fill = '';
	tb.fill = 'black';
	tb.gradient.visible = true;
	tb.gradient.colors = ['red', 'yellow', 'green'];
	tb.gradient.direction = 'rightleft';
	tb.visible = false;
	tb.radius = 0;

	var mi = (this.minor = new Format(this.chart));
	mi.stroke.fill = 'silver';
	mi.visible = true;
	mi.count = 4;
	mi.shape = ''; // ellipse

	var mb = (this.minorBack = new Format(this.chart));
	mb.stroke.fill = '';
	mb.visible = false;
	mb.fill = 'white';
	mb.gradient.visible = false;
	mb.gradient.direction = 'leftright';
	mb.gradient.colors = ['green', 'yellow', 'red'];
	mb.radius = 0;
	// shape background
	let shapeBackground = (this.back = new Format(this.chart));
	shapeBackground.fill = 'black';
	shapeBackground.visible = true;
	shapeBackground.gradient.visible = false;
	shapeBackground.gradient.colors = ['rgba(255,126,95,0.8)', 'rgba(254,180,123,0.8)'];
	shapeBackground.stroke.fill = '';

	let pointer = (this.pointer = new Format(this.chart));
	pointer.size = 3;
	pointer.fill = 'black';
	pointer.stroke.fill = '';
	pointer.visible = false;

	var mf = this.marks.format;
	mf.fill = 'black';
	mf.font.fill = 'black';
	mf.gradient.visible = true;
	mf.gradient.colors = ['rgba(255,126,95,0.6)', 'rgba(254,180,123,0.6)'];
	mf.shadow.visible = true;
	mf.shadow.blur = 8;
	mf.shadow.color = 'black';

	var f = this.format;
	f.visible = true;
	f.gradient.visible = true;
	f.gradient.colors = ['white'];
	f.shadow.visible = true;
	f.font.style = '12px Verdana';
	f.font.fill = 'black';
	f.font.visible = true;
	f.size = 2; // %
	f.round = { x: 6, y: 6 };

	f.padding = 0; // %

	this.units = new Annotation(this.chart);
	this.units.transparent = true;
	this.units.format.font.fill = 'black';
	this.units.location = { x: 0, y: 24 }; // %

	this.bounds = this.getRect();

	// markers (Text, Value and Units)
	this.markers = [];
	this.addValueMarker = function() {
		let marker = new Format(this.chart);

		marker.fill = 'white';
		marker.font.fill = 'black';
		marker.font.style = '82px Arial';
		marker.stroke.color = 'white';
		marker.text = '0';

		marker.location = { x: 38, y: 6 }; // %
		marker.position = { x: 30, y: 40 }; // %
		marker.width = 60; // %
		marker.height = 88; // %

		marker.shape = 'rectangle';

		marker.visible = true;

		this.markers.push(marker);
		return marker;
	};
	let valueMarker = (this.valueMarker = this.addValueMarker());
	this.addTextMarker = function() {
		let marker = new Format(this.chart);

		marker.fill = 'white';
		marker.font.fill = 'black';
		marker.font.style = '40px Arial';
		marker.font.textAlign = "left";
		marker.stroke.color = 'white';
		marker.text = 'FREQ';

		marker.location = { x: 1, y: 5 }; // %
		marker.position = { x: 37, y: 25 }; // %
		marker.width = 20; // %
		marker.height = 20; // %

		marker.shape = 'rectangle';

		marker.visible = true;

		this.markers.push(marker);
		return marker;
	};
	let textMarker = (this.textMarker = this.addTextMarker());
	this.addUnitsMarker = function() {
		let marker = new Format(this.Chart);
		marker.fill = 'white';
		marker.font.fill = 'black';
		marker.font.style = '40px Arial';
		marker.font.textAlign = "left";
		marker.stroke.color = 'white';
		marker.text = 'Mhz';

		marker.location = { x: 1, y: 55 }; // %
		marker.position = { x: 37, y: 32 }; // %
		marker.width = 20; // %
		marker.height = 41; // %

		marker.shape = 'rectangle';

		marker.visible = true;

		this.markers.push(marker);
		return marker;
	};
	let unitsMarker = (this.unitsMarker = this.addUnitsMarker());

	this.hover.enabled = true;

	var oldValue,
		newValue,
		gauge = this;

	this.animate = new Animation(this.chart, function(f) {
		gauge.value = oldValue + f * (newValue - oldValue);
		gauge.chart.draw();
	});

	this.animate.duration = 100;
	this.animate.onstop = function() {
		gauge.value = newValue;

		if (gauge.onchange) gauge.onchange(gauge);

		gauge.chart.draw();
	};

	var tick0, tick1, tickMin, tickText, initRot, endRot, cx, cy, cex, cey;

	this.calcBounds = function() {
		return this.bounds.custom ? this.bounds : this.cellRect(this.bounds, true);
	};

	this.draw = function() {
		let numericGauge = this,
			ctx = numericGauge.chart.ctx;

		const bounds = this.calcBounds();

		function drawShape(back) {
			if (back.visible) {
				ctx.fillStyle = back.fill;
				ctx.fillRect(0, 0, bounds.width, bounds.height);
				ctx.save();
			}
		}
		this.drawMarker = function(marker) {
			if (marker.visible) {
				// marker shape
				const shapeWidth = (bounds.width * marker.width) / 100;
				const shapeHeight = (bounds.height * marker.height) / 100;
				const shapeLocation = { x: (bounds.width * marker.location.x) / 100, y: (bounds.height * marker.location.y) / 100 };
				ctx.fillStyle = marker.fill;
				ctx.fillRect(shapeLocation.x, shapeLocation.y, shapeWidth, shapeHeight);
				ctx.font = marker.font.style;
				ctx.fillStyle = marker.font.fill;
				// marker text
				const lblX = shapeLocation.x + (shapeWidth * marker.position.x) / 100;
				const lblY = shapeLocation.y + (shapeHeight * marker.position.y) / 100;
				ctx.fillText(marker.text, lblX, lblY);
				ctx.save();
			}
		};

		drawShape(this.back);
		this.markers.forEach(marker => this.drawMarker(marker));

	};

	this.limitValue = function(v) {
		return Math.min(this.max, Math.max(this.min, v));
	};

	this.setValue = function(v) {
		v = this.limitValue(v);

		var res = this.value != v;

		if (res) {
			if (this.animate.active && this.animate.duration > 0) {
				oldValue = this.value;
				newValue = v;
				this.animate.animate(this.chart);
			} else {
				this.value = v;

				if (this.onchange) this.onchange(this);
			}
		}
		this.valueMarker.text = v.toFixed();

		return res;
	};

	this.onclick = function() {};

	this.clicked = function() {
		this.dragging = false;
		return -1;
	};

	this.inValue = function(p, r) {
		if (!r.contains(p)) return false;

		var dx = p.x - cex,
			dy = p.y - cey,
			d = Math.sqrt(dx * dx + dy * dy);

		var ang = Math.atan2(dy, dx) - Math.PI * 0.5;
		while (ang < 0) ang += 6.283;

		var rIni, rEnd, val;

		if (initRot > endRot) {
			rIni = endRot;
			rEnd = initRot;
			val = ang >= rEnd || ang <= rIni;
		} else {
			rEnd = endRot;
			rIni = initRot;
			val = ang >= rIni && ang <= rEnd;
		}

		if (val) {
			var res;

			if (initRot > endRot)
				if (ang > rEnd) res = (ang - rEnd) / (6.283 - rEnd + rIni);
				else res = (6.283 - rEnd + ang) / (6.283 - rEnd + rIni);
			else res = (ang - rIni) / (rEnd - rIni);

			var v = this.min + (this.max - this.min) * res;

			if (this.inverted) v = this.min + (this.max - this.min) * (1 - res);

			p.value = v;

			p.inTicks = d >= Math.min(tick0, tickText) && d <= tick1;

			return true;
		} else {
			p.inTicks = false;
			return false;
		}
	};

	function changeHover(g, v) {
		if (g.hover.value != v) {
			g.hover.value = v;
			g.hover.valid = v !== null;
			requestAnimationFrame(function() {
				g.chart.draw();
			});
		}
	}
	this.mousemove = function(p) {
		var r = this.calcBounds(),
			ok = this.inValue(p, r);
		if (this.dragging || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && this.drag.enabled)) {
			if (ok && this.setValue(p.value)) this.chart.draw();

			this.chart.newCursor = 'pointer';
		} else if (p.inTicks && this.drag.enabled) {
			changeHover(this, p.value);
			this.chart.newCursor = 'pointer';
		} else changeHover(this, null);
	};

	var p = { x: 0, y: 0 };

	this.mousedown = function(e) {
		if (this.drag.enabled) {
			var r = this.calcBounds();
			this.chart.calcMouse(e, p);

			if (this.inValue(p, r)) {
				this.dragging = true;

				this.hover.value = null;
				this.hover.valid = false;

				if (this.setValue(p.value)) this.chart.draw();
			} else this.dragging = false;

			return this.dragging;
		} else return false;
	};
};

NumericGauge.prototype = new Series();

/**
 * @private
 */
NumericGauge.prototype.setChart = function(series, chart) {
	var tmp = Tee.Series.prototype.setChart;
	tmp(series, chart);

	this.chart.panel.margins.bottom = 0;
	this.chart.panel.margins.right = 0;
	this.chart.panel.margins.top = 0;
	this.chart.panel.margins.left = 0;

	series.back.setChart(chart);
	series.center.setChart(chart);
	series.center.top.setChart(chart);
	series.ticks.setChart(chart);
	series.ticksBack.setChart(chart);
	series.minor.setChart(chart);
	series.minorBack.setChart(chart);
	series.units.setChart(chart);
	series.pointer.setChart(chart);
	series.bevel.setChart(chart);
};

export { NumericGauge }

